export default "__VITE_ASSET__kJORJNLV__"